function initRoketReadMore() {
  document.querySelectorAll(".block-product__description").forEach((desc) => {
    if (desc.dataset.readMoreInitialized === "true") return;

    const originalHTML = desc.innerHTML.trim();
    const fullText = desc.textContent.trim();

    if (!fullText) return;

    desc.dataset.readMoreInitialized = "true";

    function getLineLimit() {
      if (window.innerWidth <= 749) return 5;
      if (window.innerWidth <= 989) return 2;
      return 3;
    }

    function getLineHeight() {
      const styles = window.getComputedStyle(desc);
      const lineHeight = parseFloat(styles.lineHeight);
      const fontSize = parseFloat(styles.fontSize);
      return Number.isNaN(lineHeight) ? fontSize * 1.4 : lineHeight;
    }

    function renderButton(text) {
      const button = document.createElement("button");
      button.type = "button";
      button.className = "roket-read-more";
      button.textContent = text;
      desc.appendChild(button);
    }

    function collapse() {
      desc.classList.add("is-ready");
      desc.classList.remove("is-expanded");

      const maxHeight = getLineHeight() * getLineLimit();

      let start = 0;
      let end = fullText.length;
      let best = "";

      while (start <= end) {
        const mid = Math.floor((start + end) / 2);
        const testText = fullText.slice(0, mid).trim().replace(/\s+\S*$/, "");

        desc.innerHTML = `${testText}... `;
        renderButton("Read more");

        if (desc.scrollHeight <= maxHeight + 1) {
          best = testText;
          start = mid + 1;
        } else {
          end = mid - 1;
        }
      }

      desc.innerHTML = `${best}... `;
      renderButton("Read more");
      desc.classList.add("is-collapsed");
    }

    function expand() {
      desc.innerHTML = originalHTML + " ";
      renderButton("Read less");
      desc.classList.add("is-ready", "is-expanded");
      desc.classList.remove("is-collapsed");
    }

    desc.addEventListener("click", (event) => {
      if (!event.target.classList.contains("roket-read-more")) return;

      event.preventDefault();

      if (desc.classList.contains("is-expanded")) {
        collapse();
      } else {
        expand();
      }
    });

    collapse();
  });
}

document.addEventListener("DOMContentLoaded", initRoketReadMore);
document.addEventListener("shopify:section:load", initRoketReadMore);


function initRoketVariantSwatches() {
  const STORAGE_KEY = `roketSwatchesExpanded:${window.location.pathname}`;
  const VISIBLE_ROWS = 3;

  const SHOW_MORE_TEXT = "Visa alla";
  const SHOW_LESS_TEXT = "Visa färre";

  const isExpanded = () => localStorage.getItem(STORAGE_KEY) === "true";
  const setExpanded = (val) => localStorage.setItem(STORAGE_KEY, val ? "true" : "false");

  function getRowIndex(swatches, swatch) {
    const rowTops = [];

    swatches.forEach((item) => {
      const top = item.offsetTop;

      if (!rowTops.some((savedTop) => Math.abs(savedTop - top) <= 2)) {
        rowTops.push(top);
      }
    });

    rowTops.sort((a, b) => a - b);

    return rowTops.findIndex((savedTop) => Math.abs(savedTop - swatch.offsetTop) <= 2);
  }

  function setupOption(option) {
    const list = option.querySelector(".swatch-color");
    if (!list) return;

    const swatches = Array.from(list.querySelectorAll(".variant-input"));
    if (!swatches.length) return;

    option.querySelector(".swatch-show-more")?.remove();

    swatches.forEach((swatch) => {
      swatch.classList.remove("is-hidden-swatch");
    });

    option.getBoundingClientRect();

    const overflow = swatches.filter((swatch) => {
      return getRowIndex(swatches, swatch) >= VISIBLE_ROWS;
    });

    if (!overflow.length) return;

    overflow.forEach((swatch) => {
      swatch.classList.toggle("is-hidden-swatch", !isExpanded());
    });

    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "swatch-show-more";
    btn.textContent = isExpanded() ? SHOW_LESS_TEXT : SHOW_MORE_TEXT;

    btn.addEventListener("click", () => {
      const next = !isExpanded();

      setExpanded(next);

      overflow.forEach((swatch) => {
        swatch.classList.toggle("is-hidden-swatch", !next);
      });

      btn.textContent = next ? SHOW_LESS_TEXT : SHOW_MORE_TEXT;
    });

    option.appendChild(btn);
  }

  function setupAll() {
    document.querySelectorAll(".product-variants-option").forEach(setupOption);
  }

  function setupAfterLayout() {
    requestAnimationFrame(() => {
      requestAnimationFrame(setupAll);
    });
  }

  setupAfterLayout();

  window.addEventListener("load", setupAfterLayout);
  document.addEventListener("shopify:section:load", setupAfterLayout);

  if (!window.roketVariantSwatchesFetchPatched) {
    window.roketVariantSwatchesFetchPatched = true;

    const originalFetch = window.fetch;

    window.fetch = async function (...args) {
      const url = typeof args[0] === "string" ? args[0] : args[0]?.url ?? "";

      if (url.includes("section_id") && !isExpanded()) {
        const style = document.createElement("style");
        style.id = "roket-swatch-preload";
        style.textContent = ".product-variants-option .variant-input { visibility: hidden !important; }";
        document.head.appendChild(style);
      }

      const response = await originalFetch.apply(this, args);

      if (url.includes("section_id")) {
        response.clone().text().then(() => {
          setupAfterLayout();
          document.getElementById("roket-swatch-preload")?.remove();
        });
      }

      return response;
    };
  }

  if (!window.roketVariantSwatchesResizeReady) {
    window.roketVariantSwatchesResizeReady = true;

    window.addEventListener("resize", () => {
      clearTimeout(window._roketResizeTimer);
      window._roketResizeTimer = setTimeout(setupAfterLayout, 150);
    });
  }
}

document.addEventListener("DOMContentLoaded", initRoketVariantSwatches);
document.addEventListener("shopify:section:load", initRoketVariantSwatches);


function initRoketDropdownLabels() {
  document.querySelectorAll('fieldset[data-option-position="2"]').forEach((fieldset) => {
    const triggerValue = fieldset.querySelector(".variants__option-dropdown .option_value");
    if (!triggerValue) return;

    if (fieldset.dataset.roketDropdownInitialized !== "true") {
      fieldset.dataset.roketDropdownInitialized = "true";

      fieldset.addEventListener("change", () => {
        const checked = fieldset.querySelector(".variant-options:checked");
        const checkedLabel = checked?.nextElementSibling;
        if (!checkedLabel) return;

        triggerValue.textContent = checkedLabel.textContent.trim();
      });
    }

    const checked = fieldset.querySelector(".variant-options:checked");
    const checkedLabel = checked?.nextElementSibling;

    if (checkedLabel) {
      triggerValue.textContent = checkedLabel.textContent.trim();
    }
  });
}

document.addEventListener("DOMContentLoaded", initRoketDropdownLabels);
document.addEventListener("shopify:section:load", initRoketDropdownLabels);


function fixCalendarHeight() {
  const harness = document.querySelector(".fc-view-harness-active");
  const scroller = document.querySelector(".fc-scroller-liquid-absolute, .fc-scroller-liquid");

  if (harness) {
    harness.style.setProperty("height", "auto", "important");
    harness.style.setProperty("min-height", "unset", "important");
  }

  if (scroller) {
    scroller.style.setProperty("height", "auto", "important");
    scroller.style.setProperty("position", "relative", "important");
    scroller.style.setProperty("overflow", "visible", "important");
  }
}

fixCalendarHeight();
setTimeout(fixCalendarHeight, 500);
setTimeout(fixCalendarHeight, 1500);

const calendarObserver = new MutationObserver(fixCalendarHeight);

document.addEventListener("DOMContentLoaded", function () {
  const calendar = document.querySelector(".AggregateCalendar-Main") || document.body;

  calendarObserver.observe(calendar, {
    subtree: true,
    attributes: true,
    attributeFilter: ["style"]
  });
});


document.addEventListener("DOMContentLoaded", function () {
  let injecting = false;

  function injectUpsellButtons() {
    if (injecting) return;

    injecting = true;

    document.querySelectorAll(".roket-main-cart-upsell-product .product-item__inner").forEach((inner) => {
      if (inner.querySelector(".roket-upsell-btn-form")) return;

      const link = inner.querySelector("a.product__name");
      if (!link) return;

      const href = link.getAttribute("href").split("?")[0];

      fetch(href + ".js")
        .then((response) => response.json())
        .then((data) => {
          const variantId = data.variants?.[0]?.id;
          if (!variantId) return;
          if (inner.querySelector(".roket-upsell-btn-form")) return;

          const form = document.createElement("form");
          form.className = "roket-upsell-btn-form";
          form.action = "/cart/add";
          form.method = "post";
          form.innerHTML = `
            <input type="hidden" name="id" value="${variantId}">
            <input type="hidden" name="quantity" value="1">
            <button type="submit" class="btn btn-primary roket-upsell-btn">Add</button>
          `;

          inner.appendChild(form);
        })
        .finally(() => {
          injecting = false;
        });
    });

    injecting = false;
  }

  injectUpsellButtons();

  const upsellObserver = new MutationObserver(() => {
    if (!document.querySelector(".roket-main-cart-upsell-product .product-item__inner:not(:has(.roket-upsell-btn-form))")) return;

    injectUpsellButtons();
  });

  const upsell = document.querySelector(".roket-main-cart-upsell-product");

  if (upsell) {
    upsellObserver.observe(upsell, {
      childList: true,
      subtree: true
    });
  }
});